@let candidateValue = candidate();

@if (candidateValue) {
  <rt-button
    #requestEvaluationDropdownOrigin="rtOverlayOrigin"
    variant="outline"
    [pressed]="requestEvaluationDropdown.open"
    [rtTooltip]="'app.interview.request_evaluation' | translate"
    [rtTooltipEnabled]="iconOnly()"
    (click)="onTriggerClick(requestEvaluationDropdown)"
    rt-overlay-origin
  >
    @if (isEvaluationFormsEntitled()) {
      <rt-icon name="account-group" />
    } @else {
      <rt-icon [rtFeaturePlanIconColor]="GuardedFeature.EvaluationForms" name="upgrade" />
    }
    @if (!iconOnly()) {
      <span> {{ 'app.interview.request_evaluation' | translate }}</span>
    }
  </rt-button>

  <ng-template
    #requestEvaluationDropdown="rtConnectedOverlay"
    [positions]="positions"
    [origin]="requestEvaluationDropdownOrigin"
    (backdropClick)="requestEvaluationDropdown.open = false"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-request-evaluation-dropdown
      [offers]="offers()"
      [candidateId]="candidateValue.id"
      (close)="requestEvaluationDropdown.open = false"
      (submit)="onSubmit($event)"
    />
  </ng-template>
}
